import React from 'react';
import { EnterpriseItemType } from '../searchAutocomplete.types';
import { AutocompleteItem } from '../AutocompleteItem';
import {
  AutocompleteEntityItem,
  AutocompleteEntityItemLabel,
} from '../entities/EntitiesLib';
import { wantToOpenInNewTab } from '../../../../../utils/linkUtils';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { getEnterpriseUrl } from '../autocompleteUtils';
import { ReactComponent as Enterprise } from '../../../../../../icons/entities/enterprise.svg';
import { openNewTab } from '../../../../../utils/domUtils';
import { AutocompleteIcon } from '../icon/AutocompleteIcon';

type Props = {
  item: EnterpriseItemType;
  label: string;
  selected: boolean;
  hasOffset: boolean;
  onClick: () => void;
};

class RawAutocompleteEnterpriseItem extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.source = 'autocomplete_result';
  }

  onClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    const { item, onClick } = this.props;
    const lawyerPageUrl = buildUrlWithParameters(getEnterpriseUrl(item), {
      source: this.source,
    });
    onClick();
    if (wantToOpenInNewTab(event)) {
      openNewTab(lawyerPageUrl);
    } else {
      window.location.href = lawyerPageUrl;
    }
  };

  source: string;

  render() {
    const { selected, label, hasOffset } = this.props;
    return (
      <AutocompleteItem
        data-test-id="autocomplete-enterprise-item"
        hasOffset={hasOffset}
        isSelected={selected}
        onClick={this.onClick}
      >
        <AutocompleteEntityItem selected={selected} title={label}>
          <AutocompleteIcon icon={Enterprise} />
          <AutocompleteEntityItemLabel>{label}</AutocompleteEntityItemLabel>
        </AutocompleteEntityItem>
      </AutocompleteItem>
    );
  }
}

export const AutocompleteEnterpriseItem = RawAutocompleteEnterpriseItem;
